import { StickersKeyName } from '@src/components/CustomEmojiPicker/constants';
import env from '../utils/env';

const keepKeysOnLogout = [
  'userid',
  'activeChat',
  'agentChatComposeTextRows',
  'partnerCustomUi',
  'b2chat-theme-mode',
  StickersKeyName,
];

const isAStickerKey = key => key.startsWith('blob:');

const isFormFilters = key => key.includes('filters');

const isEmailOtpReminder = key => key.includes('email-otp-reminder');

//todo set reCaptchaSiteKey according to environment
let reCaptchaSiteKey = '6LfJBEYUAAAAAKUINO1mqXyS0eiI5lGp_Qu__fnJ';

try {
  if (process.env.REACT_APP_ENV === 'local') {
    reCaptchaSiteKey = '6LcuhGcUAAAAABO93bnw5O6C-0VXb7ok3vE0ePTV';
  }
} catch (_) {
  // Ignore errors attempting to set key for local environment
}

export const appConfig = {
  webServicesBaseUri: env.WEB_SERVICE_BASE_URI,
  reCaptchaSiteKey,
  getData(key) {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      return undefined;
    }
  },
  removeData(key) {
    localStorage.removeItem(key);
  },
  setData(key, data) {
    try {
      localStorage.setItem(key, JSON.stringify(data));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  },
  getCurrentUser() {
    return this.getData('loginAuthentication');
  },
  setCurrentUser(user) {
    this.setData('loginAuthentication', user);
  },
  deleteStoreData() {
    sessionStorage.removeItem('inputText');
    Object.keys(localStorage).map(key => {
      if (
        !keepKeysOnLogout.includes(key) &&
        !isAStickerKey(key) &&
        !isFormFilters(key) &&
        !isEmailOtpReminder(key)
      ) {
        localStorage.removeItem(key);
      }
      return key;
    });
  },
  characterLength: 2000,
  reasonCharacterLength: 200,
  queryCount: 100000,
  maxWidthConsole: 1400,
};

export default appConfig;
